import React, { useEffect, useRef, useState } from "react";
import { Grid } from "@mui/material";
import AppContainer from "../../../components/AppContainer";
import PlansCard from "./PlansCard";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import {
  createUserSubscription,
  fetchSubscription,
} from "../../../services/Subscription";
import { useLocation, useNavigate } from "react-router-dom";
import { Data } from "@react-google-maps/api";
import moment from "moment";
import { generateEndDatePayload } from "../../../utils";
import PlanConfirmationDialog from "./PlanConfirmationDiloge";
import { setSubscription } from "../../../lib/slices/subscription";
import { useDispatch } from "react-redux";

function AllPlans() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const openConfirmationRef = useRef();
  const [open, setOpen] = useState(false);
  const [cardData, setCardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };
  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  useEffect(() => {
    handleFetchPlans();
  }, []);

  const handleFetchPlans = async () => {
    setIsLoading(true);
    try {
      const responce = await fetchSubscription();
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        let data = await responce?.data?.data;
        let temmpArrrr = [...data];
        temmpArrrr.sort((a, b) => {
          const priceA = a.price ?? Infinity;
          const priceB = b.price ?? Infinity;
          return priceA - priceB;
        });
        setCardData(temmpArrrr);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchPlans ~ error:", error);
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  const handleClickBtn = async (data) => {
    openConfirmationRef.current.isVisible({ data: data });
  };
  const handleConfirm = async ({ data }) => {
    try {
      let payload = {
        businessId: state?._id,
        planId: data?._id,
        startDate: moment(new Data()).format("YYYY-MM-DD"),
        endDate: await generateEndDatePayload(data?.duration),
        status: "active",
      };
      setIsLoading(true);
      const responce = await createUserSubscription(payload);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        handleSnackbarVal(true, "success", responce?.data?.message);
        setOpen(false);
        localStorage.setItem("subscription", JSON.stringify(data));
        dispatch(setSubscription(data));
        setTimeout(() => {
          navigate("/login", { replace: true });
        }, 1000);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleClickBtn ~ error:", error);
    }
  };

  return (
    <AppContainer
      primaryHeading={"All Plans"}
      secondaryHeading={"You can view and selecte a plans."}
      showBackButton={true}
      height={"90vh"}
      handleBack={() => navigate("/login")}
    >
      <Grid container spacing={1} mt={3}>
        {cardData.map((val, index) => {
          return (
            <PlansCard
              val={val}
              index={index}
              handleClickBtn={handleClickBtn}
            />
          );
        })}
      </Grid>
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <PlanConfirmationDialog
        open={open}
        setOpen={setOpen}
        ref={openConfirmationRef}
        handleConfirm={handleConfirm}
      />
    </AppContainer>
  );
}

export default AllPlans;
